<template>
    <div>
        <page-title>定时任务</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div></div>
                    <div>
                        <el-form :inline="true" onsubmit="return false">
                            <el-form-item style="margin-bottom: 0;">
                                <el-radio-group size="mini" v-model="type" @change="typeChange">
                                    <el-radio-button label="/dashboard/admin/task/fail">失败记录</el-radio-button>
                                    <el-radio-button label="/dashboard/admin/task/index">创建记录</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="名称/域名/服务器IP"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="name" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.host.name}}</div>
                        <div>{{scope.row.host.domain}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="执行URL">
                    <template slot-scope="scope">
                        <div class="row-url">{{scope.row.url}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="delay_seconds" label="延时（秒）"></el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <div style="color: #909399; font-size: 12px;">{{scope.row.add_time}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            list: null,
            pagination: null,
            is_pass: null,
            keyword: '',
            type: '/dashboard/admin/task/index'
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/task/index',
                    params: {
                        page: page,
                        keyword: this.keyword,
                        type: this.type
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        typeChange(e) {
            this.$router.push(e)
        }
    }
}
</script>

<style scoped>
.row-url {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
